import Category from "./service-category";
import Flow from "./flow";

// Type for YAML-based services
export interface YamlService {
  id: string;
  yamlId?: string;
  slug: string;
  title?: string;
  name?: string;
  logo?: any;
  description?: { description?: string } | string;
  url?: string;
  category?: any;
  flows?: any[];
}

export default class Service {
  id: string;
  yamlId?: string;
  slug: string;
  name: string;
  logo: any;
  description: string;
  url: string;
  category: Category;
  flows: Flow[];

  constructor(service: YamlService) {
    this.id = service.id;
    this.yamlId = service.yamlId;
    this.slug = service.slug!;
    this.name = service.title || service.name!;
    this.description =
      typeof service.description === "string"
        ? service.description
        : service.description?.description || "";
    this.url = service.url || "";
    this.logo = service.logo as any;
    this.category = new Category(service.category!);
    this.flows = service.flows?.map((flow: any) => new Flow(flow!)) || [];
  }
}
